import { styled } from 'styled-components';
import { mediaQuery } from '../styles/styles.js';

// ------------------ TYPOGRAPHY

export const H1Bold = styled.h1`
  font-weight: bold;
`;

export const H2Bold = styled.h2`
  font-weight: bold;
`;

export const TextBold = styled.p`
  font-weight: bold;
`;

export const SmallBold = styled.small`
  font-weight: bold;
`;

// ------------------ UTILS

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Card = styled.div<{ level?: 0 | 100 | 200 | 300 | 400 }>`
  padding: 16px;
  border-radius: 16px;
  border: ${props => (props.level !== undefined ? 'none' : `1px solid ${props.theme.colors.dark.dark600}`)};
  background-color: ${props => (props.level !== undefined ? (props.level === 0 ? props.theme.colors.background : props.theme.colors.dark[`dark${props.level}`]) : 'inherit')};

  @media ${mediaQuery.desktop} {
    padding: 32px;
  }
`;

export const Banner = styled.p<{ $severity?: 'error' | 'confirm' | 'info' | 'warning' }>`
  border-radius: 4px;
  padding: 8px;
  border: ${props => {
    if (props.$severity === 'info') return `1px dashed ${props.theme.colors.orange.orange90}`;
  }};
  color: ${props => {
    if (props.$severity === 'info') return props.theme.colors.text;
    return props.theme.colors.dark.dark100;
  }};
  background-color: ${props => {
    if (props.$severity === 'error') return '#e38982';
    if (props.$severity === 'confirm') return props.theme.colors.green;
    if (props.$severity === 'warning') return props.theme.colors.orange.orange80;
  }};
`;
